<template>
  <BasePageContainer>
    <SettingHeader>ノートテンプレートの管理</SettingHeader>
    <div class="pt-10 pb-4">
      <!-- 管理者・限定指導者はどのグループにもテンプレートを作成できるため選択肢は全グループ -->
      <NoteTemplateForm
        v-if="initialized"
        :department-options="allDepartments"
        :response-errors="responseErrors"
        @submit="submit" />
    </div>
  </BasePageContainer>
</template>

<script>
import SettingHeader from '@/components/parts/SettingHeader.vue'
import NoteTemplateForm from '@/components/view/note_templates/NoteTemplateForm.vue'
import allDepartments from '@/components/mixin/allDepartments'

export default {
  name: 'NoteTemplateAdd',
  components: {
    SettingHeader,
    NoteTemplateForm
  },
  mixins: [allDepartments],
  data() {
    return {
      responseErrors: {},
      initialized: false
    }
  },
  async created() {
    this.$store.commit('startLoading')
    const fetched = await this.fetchAllDepartments()
    this.$store.commit('finishLoading')
    // グループを取得できないまま作成させると意図しない公開範囲で保存されるため一覧へ戻す
    if (!fetched) {
      this.$router.push('/admin/note_templates/')
      return
    }
    this.initialized = true
  },
  methods: {
    async submit(body) {
      this.$store.commit('startLoading')
      await this.$axios.post('/note_templates/', body).then(res => {
        this.$store.commit('notify/set', { message: `${res.data.name}を作成しました。` })
        this.$router.push('/admin/note_templates/')
      }).catch(e => {
        console.error(e)
        this.responseErrors = e.response?.data || {}
        this.$store.commit('notify/set', { isUnknownError: true, type: 'danger' })
      })
      this.$store.commit('finishLoading')
    }
  }
}
</script>

<style scoped>
</style>
